import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const WS_BASE_URL = API_BASE_URL.replace('http', 'ws');

export const liveService = {
  // ==================== Live Configuration ====================
  
  getLiveConfig: async () => {
    try {
      const response = await api.get('/api/live/admin/config');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get live config error:', error);
      let errorMessage = 'Failed to load live configuration';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to load live configuration';
      }
      return {
        success: false,
        error: errorMessage,
        data: null
      };
    }
  },

  updateLiveConfig: async (config) => {
    try {
      const response = await api.put('/api/live/admin/config', config);
      return {
        success: true,
        data: response.data,
        message: 'Configuration updated successfully'
      };
    } catch (error) {
      console.error('Update live config error:', error);
      let errorMessage = 'Failed to update live configuration';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to update live configuration';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  // ==================== Restaurants ====================
  
  getRestaurants: async () => {
    try {
      const response = await api.get('/api/live/admin/restaurants');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get restaurants error:', error);
      let errorMessage = 'Failed to load restaurants';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to load restaurants';
      }
      return {
        success: false,
        error: errorMessage,
        data: []
      };
    }
  },

  createRestaurant: async (restaurantData) => {
    try {
      const response = await api.post('/api/live/admin/restaurants', restaurantData);
      return {
        success: true,
        data: response.data,
        message: 'Restaurant created successfully'
      };
    } catch (error) {
      console.error('Create restaurant error:', error);
      let errorMessage = 'Failed to create restaurant';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to create restaurant';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  updateRestaurant: async (restaurantId, restaurantData) => {
    try {
      const response = await api.put(`/api/live/admin/restaurants/${restaurantId}`, restaurantData);
      return {
        success: true,
        data: response.data,
        message: 'Restaurant updated successfully'
      };
    } catch (error) {
      console.error('Update restaurant error:', error);
      let errorMessage = 'Failed to update restaurant';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to update restaurant';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  deleteRestaurant: async (restaurantId) => {
    try {
      await api.delete(`/api/live/admin/restaurants/${restaurantId}`);
      return {
        success: true,
        message: 'Restaurant deleted successfully'
      };
    } catch (error) {
      console.error('Delete restaurant error:', error);
      let errorMessage = 'Failed to delete restaurant';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to delete restaurant';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  // ==================== Sponsors ====================
  
  getSponsors: async () => {
    try {
      const response = await api.get('/api/live/admin/sponsors');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get sponsors error:', error);
      let errorMessage = 'Failed to load sponsors';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to load sponsors';
      }
      return {
        success: false,
        error: errorMessage,
        data: []
      };
    }
  },

  createSponsor: async (sponsorData) => {
    try {
      const response = await api.post('/api/live/admin/sponsors', sponsorData);
      return {
        success: true,
        data: response.data,
        message: 'Sponsor created successfully'
      };
    } catch (error) {
      console.error('Create sponsor error:', error);
      let errorMessage = 'Failed to create sponsor';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to create sponsor';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  updateSponsor: async (sponsorId, sponsorData) => {
    try {
      const response = await api.put(`/api/live/admin/sponsors/${sponsorId}`, sponsorData);
      return {
        success: true,
        data: response.data,
        message: 'Sponsor updated successfully'
      };
    } catch (error) {
      console.error('Update sponsor error:', error);
      let errorMessage = 'Failed to update sponsor';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to update sponsor';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  deleteSponsor: async (sponsorId) => {
    try {
      await api.delete(`/api/live/admin/sponsors/${sponsorId}`);
      return {
        success: true,
        message: 'Sponsor deleted successfully'
      };
    } catch (error) {
      console.error('Delete sponsor error:', error);
      let errorMessage = 'Failed to delete sponsor';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to delete sponsor';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  reorderSponsors: async (sponsorOrders) => {
    try {
      const response = await api.post('/api/live/admin/sponsors/reorder', sponsorOrders);
      return {
        success: true,
        message: response.data.message || 'Sponsors reordered successfully'
      };
    } catch (error) {
      console.error('Reorder sponsors error:', error);
      let errorMessage = 'Failed to reorder sponsors';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to reorder sponsors';
      }
      return {
        success: false,
        error: errorMessage
      };
    }
  },

  // ==================== Live Display Data (Public) ====================
  
  getLiveDisplayData: async () => {
    try {
      const response = await api.get('/api/live/display');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get live display data error:', error);
      let errorMessage = 'Failed to load live display data';
      if (error.response?.data?.detail) {
        errorMessage = typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : 'Failed to load live display data';
      }
      return {
        success: false,
        error: errorMessage,
        data: {
          config: null,
          restaurants: [],
          sponsors: [],
          tournaments: [],
          rankings: []
        }
      };
    }
  },

  // ==================== WebSocket Connection ====================
  
  connectLiveWebSocket: (onUpdate, onError) => {
    const wsUrl = `${WS_BASE_URL}/api/live/ws`;
    
    try {
      const ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        console.log('Connected to live display WebSocket');
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (onUpdate && typeof onUpdate === 'function') {
            onUpdate(data);
          }
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        if (onError && typeof onError === 'function') {
          onError(error);
        }
      };

      ws.onclose = () => {
        console.log('Disconnected from live display WebSocket');
        // Attempt reconnection after 3 seconds
        setTimeout(() => {
          console.log('Attempting to reconnect to live display WebSocket...');
          liveService.connectLiveWebSocket(onUpdate, onError);
        }, 3000);
      };

      return ws;
    } catch (error) {
      console.error('Error creating WebSocket connection:', error);
      if (onError && typeof onError === 'function') {
        onError(error);
      }
      return null;
    }
  }
};

export default liveService;

